import Page from "../../components/PageContainer/Page";
import ProjectItem from "../../components/ProjectItem/ProjectItem";
import SectionDivider from "../../components/common/SectionDivider/SectionDivider";
import styles from "./Projects.module.scss";
import AnimatedWrapper from "../../components/common/AnimatedWrapper/AnimatedWrapper";
import { useTranslation } from 'react-i18next';

const Projects = () => {
  const { t } = useTranslation();
  
  const projectsStaticData = [
    {
      galleryPath: "/portfolio/Lombart"
    },
    {
      galleryPath: "/portfolio/UDT",
      demoLink: "https://testudt.vercel.app/"
    },
    {
      galleryPath: "/portfolio/KosmicznyKursFrontend",
      demoLink: "https://kosmiczny-kurs-frontend.web.app/#/"
    },
    {
      galleryPath: "/portfolio/JellyStudio",
      demoLink: "https://jelly-studio-page.vercel.app/",
      codeLink: "https://github.com/DariuszSzymczak/jelly-studio-page"
    },
    {
      galleryPath: "/portfolio/klaudia",
      demoLink: "http://deejii-art.pl"
    },
    {
      galleryPath: "/portfolio/troai"
    },
    {
      galleryPath: "/portfolio/Paul",
      demoLink: "https://paulsorganicveg.com/"
    },
    {
      galleryPath: "/portfolio/FotoHelena"
    },
    {
      galleryPath: "/portfolio/JellyPages",
      codeLink: "https://github.com/DariuszSzymczak/jelly-pages"
    }
  ];

  const projects = t('projects.items', { returnObjects: true }).map((item, index) => ({
    ...item,
    ...projectsStaticData[index]
  }));

  return (
    <Page name="projects" background="white">
      <div className={styles.projects}>
        <div className={styles.projects__header}>
          <AnimatedWrapper>
          <h2 className={styles.projects__title}>{t('projects.title')}</h2>
          </AnimatedWrapper>
          <AnimatedWrapper>
          <SectionDivider />
          </AnimatedWrapper>
          <AnimatedWrapper>
          <p className={styles.projects__subtitle}>
            {t('projects.subtitle')}
          </p>
          </AnimatedWrapper>
        </div>

        <div className={styles.projects__grid}>
          {projects.map((project, index) => (
            <ProjectItem
              key={index}
              title={project.title}
              description={project.description}
              galleryPath={project.galleryPath}
              demoLink={project.demoLink}
              codeLink={project.codeLink}
            />
          ))}
        </div>
      </div>
    </Page>
  );
};

export default Projects; 